export default "__VITE_ASSET__a307db23__"